import { IsNotEmpty, Matches } from 'class-validator';

export class ProvisioningPublishDatasetData {
    @IsNotEmpty()
    title: string;

    description: string;
}
